import { createContext } from 'react';
import type { ComponentTemplate } from '../schema/components';

/** Template the editor is themed for — lets knob rows resolve the
 *  template's own defaults (`KnobDef.templateDefaults`). Undefined outside
 *  a template-scoped editor: rows then show the shared `default`. */
export const ConstructorTemplateContext = createContext<ComponentTemplate | undefined>(undefined);
